import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { MatLegacyDialogModule, MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { DocumentStatusEnum as LedgerImportDocumentStatusEnum, LedgerImportEntity } from '../../../dave-data-module/entities/ledger-import.entity';
import { LedgerImportDataService } from '../../../dave-data-module/services/ledger-import-data.service';
import { State } from '../../../dave-data-module/State';
import { getLedgerImportById } from '../../../dave-data-module/State/selectors/ledger-import.selector';
import { DaveLoadingModule } from '../../../dave-loading/dave-loading.module';
import { AppButtonModule } from '../../../dave-utils-module/app-button-module/app-button.module';
import { appMatDialogDefaultConfig } from '../../../helper/helper';
import { LedgerImportResolver } from '../../../dave-data-module/guards/ledger-import.resolver';

export interface PendingLedgerimportDocumentCreationDialogComponentDialogData {
    ledgerImportId: number;
}
export type PendingLedgerimportDocumentCreationDialogComponentDialogReturnData = undefined | 'finished';

@Component({
    selector: 'app-pending-ledgerimport-document-creation-dialog',
    standalone: true,
    imports: [CommonModule, MatLegacyDialogModule, AppButtonModule, DaveLoadingModule],
    templateUrl: './pending-ledgerimport-document-creation-dialog.component.html',
    styleUrls: ['./pending-ledgerimport-document-creation-dialog.component.scss'],
})
export class PendingLedgerimportDocumentCreationDialogComponent implements OnDestroy {
    public static readonly DialogConfig = {
        ...appMatDialogDefaultConfig,
    };
    ledgerImport$: Observable<LedgerImportEntity>;
    loading$: Observable<boolean>;
    failed$: Observable<boolean>;
    none$: Observable<boolean>;

    private closeSubscription: Subscription;
    private pollSubscription: Subscription;
    constructor(
        @Inject(MAT_LEGACY_DIALOG_DATA) dialogData: PendingLedgerimportDocumentCreationDialogComponentDialogData,
        dialogRef: MatLegacyDialogRef<PendingLedgerimportDocumentCreationDialogComponent, PendingLedgerimportDocumentCreationDialogComponentDialogReturnData>,
        store: Store<State>,
        api: LedgerImportDataService,
        ledgerImportResolver: LedgerImportResolver,
    ) {
        this.ledgerImport$ = store.select(getLedgerImportById({ id: dialogData.ledgerImportId }));
        const status$ = this.ledgerImport$.pipe(map((li) => li.DocumentStatus));
        this.loading$ = status$.pipe(map((s) => s === LedgerImportDocumentStatusEnum.Queued || s === LedgerImportDocumentStatusEnum.Running));
        this.failed$ = status$.pipe(map((s) => s === LedgerImportDocumentStatusEnum.Failed));
        this.none$ = status$.pipe(map((s) => s === LedgerImportDocumentStatusEnum.None));
        this.closeSubscription = status$.subscribe((s) => {
            if (s === LedgerImportDocumentStatusEnum.Finished) {
                dialogRef.close('finished');
            }
        });
        this.pollSubscription = this.loading$.pipe(distinctUntilChanged() /*, switchMap(loading => loading ? timer(0, 1000).pipe(map(() => true)) : of(false))*/).subscribe(async (loading) => {
            if (loading) {
                let running = true;
                while (running) {
                    const response = await api.getLedgerImportDocumentStatus(dialogData.ledgerImportId);
                    console.log(response);
                    if (response && (response === LedgerImportDocumentStatusEnum.Running || response === LedgerImportDocumentStatusEnum.Queued)) {
                        await sleep(1000);
                    } else {
                        ledgerImportResolver.pollUpdated();
                        running = false;
                    }
                }
            }
        });
    }
    ngOnDestroy(): void {
        this.closeSubscription.unsubscribe();
        this.pollSubscription.unsubscribe();
    }
}
// Source - https://stackoverflow.com/a
// Posted by Dan Dascalescu, modified by community. See post 'Timeline' for change history
// Retrieved 2025-11-18, License - CC BY-SA 4.0

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
